import { Stack, Typography } from "@mui/material";
import UnauthorizedImg from "../assets/images/401.png";
import Logo from "../components/Logo";
import { PrimaryButton } from "../components/form";
import { ArrowLeft } from "@phosphor-icons/react";

export default function NotAuthorized() {

  const handleGoBack = () => {
    window.location.href = "/";
  }

  return (
    <Stack alignItems={"center"} textAlign={"center"} justifyContent={"space-around"} gap={4} py={2}>
      <Logo />
      <img src={UnauthorizedImg} style={{ maxHeight: 368, maxWidth: 368 }} />
      <Typography variant="heading2-helveticaNeue-medium">OPPS! Unauthorized Access</Typography>
      <Typography variant="bodyLarge-helveticaNeue" color={"textSecondary"}>
        It looks like you’re not authorized to access this page. Try logging in with a different account or go back to the homepage.
      </Typography>
      <PrimaryButton onClick={handleGoBack} startIcon={<ArrowLeft />}>Back</PrimaryButton>
    </Stack>
  )
}
